import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { bootstrapVisionForge } from "./forge/bootstrap";

bootstrapVisionForge();

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
